import { Component, Inject, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { BasicService } from 'src/app/shared/services/basic.service';

import { CountersService } from '../services/counters.service';
import { NavigationService } from '../services/navigation.service';
import { QueueIdEnum } from '../shared/enums';
import { Counter, TaskListConfiguration } from '../shared/models';

/**
 * counters for colored inserts "by me" in received tab
 */
@Component({
  selector: 'app-inserts-by-me',
  templateUrl: './inserts-by-me.component.html',
  styleUrls: ['./inserts-by-me.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class InsertsByMeComponent implements OnInit, OnDestroy {
  @Input() taskListConfiguration: TaskListConfiguration;
  private stateInboxNg = `auth.alcmeon.inbox.list.tasks`;
  byMeCounterConfigs: TaskListConfiguration[];
  insertAssigned = '';
  insertOnHold = '';
  insertHelpResquest = '';

  private subscriptions = new Subscription();

  constructor(
    private basicService: BasicService,
    private countersService: CountersService,
    private navigationService: NavigationService,
    @Inject('$state') private $state: any
  ) {
    // this subscribe needs to be in constructor, to be subscribed before the init of all three components : this one, ChannelsNavigationComponent, TabsNavigationComponent
    this.subscriptions.add(
      this.countersService.countersBS.subscribe(counters => {
        this.updateCountersForDisplay(counters);
      })
    );
  }

  ngOnInit(): void {
    this.byMeCounterConfigs = this.navigationService.getByMeCounterConfigs();
    this.countersService.initByMeCounters(this.byMeCounterConfigs, this.taskListConfiguration);
  }

  /**
   * Inject counters in byMeTaskListConfigs
   */
  updateCountersForDisplay(counters: Counter[]) {
    if (this.byMeCounterConfigs?.length && counters?.length) {
      let counterIndex = 0;

      this.byMeCounterConfigs.forEach(config => {
        config.counterIndex = this.countersService.byMeCounterIndexes[counterIndex];
        counterIndex++;

        if (config.counterIndex >= 0 && counters[config.counterIndex]) {
          config.counter = [counters[config.counterIndex].counter];
        }
      });

      // construct translations with counters
      if (this.taskListConfiguration.queueId === QueueIdEnum.Received) {
        if (this.byMeCounterConfigs[0].counter?.length) {
          const assignedCounter = this.byMeCounterConfigs[0].counter[0];
          const assignedKey = 'inbox/task-list/counter-insert/assigned/';
          const assignedParam = { nb: `${assignedCounter}` };

          if (assignedCounter === 1) {
            this.insertAssigned = this.basicService.translate(`${assignedKey}s`, assignedParam);
          } else if (assignedCounter > 1) {
            this.insertAssigned = this.basicService.translate(`${assignedKey}p`, assignedParam);
          } else {
            this.insertAssigned = '';
          }
        }

        if (this.byMeCounterConfigs[1].counter?.length) {
          const onHoldCounter = this.byMeCounterConfigs[1].counter[0];
          const onHoldKey = 'inbox/task-list/counter-insert/on_hold/';
          const onHoldParam = { nb: `${onHoldCounter}` };

          if (onHoldCounter === 1) {
            this.insertOnHold = this.basicService.translate(`${onHoldKey}s`, onHoldParam);
          } else if (onHoldCounter > 1) {
            this.insertOnHold = this.basicService.translate(`${onHoldKey}p`, onHoldParam);
          } else {
            this.insertOnHold = '';
          }
        }

        if (this.byMeCounterConfigs[2].counter?.length) {
          const helpRequestCounter = this.byMeCounterConfigs[2].counter[0];
          const helpRequestKey = 'inbox/task-list/counter-insert/help_requested/';
          const helpRequestParam = { nb: `${helpRequestCounter}` };

          if (helpRequestCounter === 1) {
            this.insertHelpResquest = this.basicService.translate(`${helpRequestKey}s`, helpRequestParam);
          } else if (helpRequestCounter > 1) {
            this.insertHelpResquest = this.basicService.translate(`${helpRequestKey}p`, helpRequestParam);
          } else {
            this.insertHelpResquest = '';
          }
        }
      }
    }
  }

  goToOngoingByMe() {
    this.$state.go(
      this.stateInboxNg,
      {
        queueId: QueueIdEnum.AssignedToYou,
      },
      {
        reload: this.stateInboxNg,
      }
    );
  }

  goToHelpRequest() {
    this.$state.go(
      this.stateInboxNg,
      {
        queueId: QueueIdEnum.HelpRequested,
      },
      {
        reload: this.stateInboxNg,
      }
    );
  }

  ngOnDestroy(): void {
    this.subscriptions?.unsubscribe();
  }
}
